import { Component, OnInit } from '@angular/core';
import loacleEsClExtra from '@angular/common/locales/extra/es-CL';
import { registerLocaleData } from '@angular/common';
import localeEsCl from '@angular/common/locales/es-CL';
import { ClientService } from './components/client.service';
import { Comapnies } from './data';
import { AuthService } from '../../authentication/service/auth.service';
import { FilterPagination } from '../files-clients/interface/company-client.interface';

registerLocaleData(localeEsCl, 'es-CL', loacleEsClExtra);

@Component({
  selector: 'app-clients',
  templateUrl: './clients.component.html',
  styleUrls: ['./clients.component.scss'],
})
export class ClientsComponent implements OnInit {
  public companies: Array<Comapnies> = [];
  public userId = parseInt(this.authService.getRutUser());

  constructor(private clientService: ClientService, private authService: AuthService) {

  }

  ngOnInit(): void {
    this.getComaponiesAssociated();
  }

  public getComaponiesAssociated() {
    this.clientService.getMyCompanies(this.userId).subscribe({
      next: (response) => {
        this.companies = response;
      },
      error: (e) => {
        console.log(e);
      }
    });
  }

}